
import { useState, useEffect, useCallback } from 'react';
import { Customer } from '@/lib/supabase/customers/types';

export const useCustomerSelection = (customers: Customer[] = []) => {
  const [selectedCustomers, setSelectedCustomers] = useState<string[]>([]);
  const [editingCustomerId, setEditingCustomerId] = useState<string | null>(null);
  const [addingCustomer, setAddingCustomer] = useState(false);

  // Reset selection when customers change if needed
  useEffect(() => {
    if (customers.length > 0) {
      // Keep only valid selections when customers change
      setSelectedCustomers(prev => 
        prev.filter(id => customers.some(customer => customer.id === id))
      );
    }
  }, [customers]);

  // Toggle customer selection
  const toggleCustomerSelection = useCallback((id: string) => {
    console.log('Toggling customer selection for ID:', id);
    setSelectedCustomers(prev => 
      prev.includes(id) ? prev.filter(customerId => customerId !== id) : [...prev, id]
    );
  }, []);

  // Toggle select all
  const toggleSelectAll = useCallback(() => {
    console.log('Toggle select all - current count:', selectedCustomers.length, 'total customers:', customers.length);
    setSelectedCustomers(prev => {
      if (prev.length === customers.length) {
        return [];
      } else {
        return customers.map(customer => customer.id);
      }
    });
  }, [customers, selectedCustomers.length]);

  // Check if all customers are selected
  const areAllSelected = customers.length > 0 && selectedCustomers.length === customers.length;

  // Handle opening customer edit form
  const handleEditCustomer = (id: string) => {
    setEditingCustomerId(id);
  };

  // Handle adding a new customer
  const handleAddCustomerForm = () => {
    setAddingCustomer(true);
  };

  // Handle closing the form
  const handleCloseForm = () => {
    setEditingCustomerId(null);
    setAddingCustomer(false);
  };

  return {
    selectedCustomers,
    editingCustomerId,
    addingCustomer,
    setAddingCustomer,
    toggleCustomerSelection,
    toggleSelectAll,
    areAllSelected,
    handleEditCustomer,
    setEditingCustomerId,
    handleAddCustomerForm,
    handleCloseForm
  };
};

// Pour la rétrocompatibilité
export const useClientSelection = useCustomerSelection;
